import CloudinaryImage from '@/components/CloudinaryImage'
import AnimatedScarcityMeter from '@/components/Meter/AnimatedScarcityMeter'
import PinElements from '@/components/PinElements'
import { ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH } from '../../constants'
import useBreakpoints from '@/hooks/useBreakpoints'

const mediaPath = 'pages/arcade/overview/'

const ArcadeOverviewScarcity = ({}) => {
  const { isMobile } = useBreakpoints()
  const scareCityBg = isMobile ? 'scarecity-hero-mobile' : 'scarecity-hero'

  return (
    <div className="container flex flex-col items-center gap-2 max-w-[922px]">
      <AnimatedScarcityMeter className="w-full max-w-[132px]" />
      <h3 className="h3 text-center">Welcome to scarcity</h3>
      <PinElements
        pins={{
          className: 'max-lg:hidden',
          items: [
            {
              element: (
                <CloudinaryImage
                  imageId={'lightning'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={305}
                  height={279}
                />
              ),
              anchor: {
                x: 0,
                y: 100
              },
              position: {
                x: 98,
                y: -34
              }
            }
          ]
        }}
      >
        <p className="text-gray-300 body-lg text-center">
          🔥 Every time you convert a digital collectible into Arcade Points,
          your item is gone forever — permanently removed from circulation. That
          means fewer items exist, making the remaining ones even more limited.
          For example, an item of Legendary rarity that started with a total
          supply of 2,000 could eventually dwindle to just a handful. Scarcity
          rises with each conversion, driving demand even higher (track it in
          real time with the new Scarcity Meter). Will you hold onto yours… or
          play the game and reshape the future of the&nbsp;collection?&nbsp;🚀
        </p>
      </PinElements>
      <PinElements
        className="w-full"
        pins={{
          className: 'max-lg:hidden z-10',
          items: [
            {
              element: (
                <CloudinaryImage
                  imageId={'small_stars'}
                  transformations={{
                    format: 'svg'
                  }}
                  path={ARCADE_OVERVIEW_BACKGROUND_CLOUDINARY_PATH}
                  width={58}
                  height={51}
                />
              ),
              anchor: {
                x: 0,
                y: 100
              },
              position: {
                x: 107,
                y: 90
              }
            }
          ]
        }}
      >
        <div className="w-full">
          <div className="relative max-h-[540px] aspect-[2874/1621]">
            <CloudinaryImage
              imageId={scareCityBg}
              path={mediaPath}
              alt="Scare City"
              layout="fill"
              objectFit="cover"
            />
          </div>
        </div>
      </PinElements>
    </div>
  )
}

export default ArcadeOverviewScarcity
